module.exports = "pegasus/assets/theme5/medium/3.jpg";